// extracted by mini-css-extract-plugin
export var container = "Countdown-module--container--47192";
export var countdown = "Countdown-module--countdown--8263e";
export var countdownItem = "Countdown-module--countdown-item--53e82";
export var countdownItemLabel = "Countdown-module--countdown-item-label--2c69c";
export var countdownItemNumber = "Countdown-module--countdown-item-number--e117f";
export var divider = "Countdown-module--divider--f509e";
export var offerEndsLabel = "Countdown-module--offer-ends-label--618b1";
export var smallContainer = "Countdown-module--small-container--ebcde";
export var smallCountdown = "Countdown-module--small-countdown--7bae4";
export var smallCountdownItem = "Countdown-module--small-countdown-item--dc4f5";
export var smallDivider = "Countdown-module--small-divider--fc895";
export var smallOfferEndsLabel = "Countdown-module--small-offer-ends-label--9d94d";